import React, { useEffect, useState } from "react";
import { MessageCircle, Mail, MapPin, Instagram, Phone } from "lucide-react";
import api from "@/lib/api";

export default function Contact() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="py-24 text-center text-text-muted">…</div>;

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-10 md:py-16 fade-in">
      <span className="text-xs tracking-luxe uppercase text-accent">RNF_Line — رنف لاين</span>
      <h1 className="font-display text-4xl mt-2 mb-8">تواصلي معنا</h1>

      <div className="grid sm:grid-cols-2 gap-4">
        <a href={`https://wa.me/${(s.whatsapp || "").replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp"
          className="flex items-center gap-3 border border-border p-5 hover:border-primary transition-colors">
          <MessageCircle className="w-5 h-5 text-accent" strokeWidth={1.5} />
          <div><div className="text-xs text-text-muted">واتساب</div><div dir="ltr">{s.whatsapp}</div></div>
        </a>
        <a href={`tel:${(s.phone || "").replace(/\s/g, "")}`} data-testid="contact-phone"
          className="flex items-center gap-3 border border-border p-5 hover:border-primary transition-colors">
          <Phone className="w-5 h-5 text-accent" strokeWidth={1.5} />
          <div><div className="text-xs text-text-muted">هاتف</div><div dir="ltr">{s.phone}</div></div>
        </a>
        <a href={`mailto:${s.email}`} data-testid="contact-email"
          className="flex items-center gap-3 border border-border p-5 hover:border-primary transition-colors">
          <Mail className="w-5 h-5 text-accent" strokeWidth={1.5} />
          <div><div className="text-xs text-text-muted">البريد الإلكتروني</div><div dir="ltr">{s.email}</div></div>
        </a>
        <a href={`https://instagram.com/${(s.instagram || "").replace("@", "")}`} target="_blank" rel="noreferrer" data-testid="contact-instagram"
          className="flex items-center gap-3 border border-border p-5 hover:border-primary transition-colors">
          <Instagram className="w-5 h-5 text-accent" strokeWidth={1.5} />
          <div><div className="text-xs text-text-muted">انستغرام</div><div dir="ltr">{s.instagram}</div></div>
        </a>
      </div>

      <div className="flex items-start gap-3 border border-border p-5 mt-4">
        <MapPin className="w-5 h-5 text-accent mt-0.5" strokeWidth={1.5} />
        <div><div className="text-xs text-text-muted mb-1">العنوان</div>{s.address}</div>
      </div>
    </div>
  );
}
